// src/utils/format.ts

const MONTHS = [
  "ene",
  "feb",
  "mar",
  "abr",
  "may",
  "jun",
  "jul",
  "ago",
  "sep",
  "oct",
  "nov",
  "dic",
];

/** Fecha "yyyy-MM-dd" (LocalDate) o ISO (LocalDateTime) → "28 sep 2026" */
export function formatDate(value?: string | null): string {
  if (!value) return "—";
  // LocalDate llega sin hora: la armamos en hora local para que no se corra un día
  const date = /^\d{4}-\d{2}-\d{2}$/.test(value)
    ? new Date(`${value}T00:00:00`)
    : new Date(value);
  if (isNaN(date.getTime())) return value;
  return `${String(date.getDate()).padStart(2, "0")} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`;
}

export function formatDateTime(value?: string | null): string {
  if (!value) return "—";
  const date = new Date(value);
  if (isNaN(date.getTime())) return value;
  return date.toLocaleString("es-CO", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** "2026-09" → "sep 2026" */
export function formatMonth(value: string): string {
  const [year, month] = value.split("-").map(Number);
  return `${MONTHS[(month || 1) - 1]} ${year}`;
}

export function fullName(
  first?: string | null,
  last?: string | null,
  fallback = "—",
): string {
  const name = `${first ?? ""} ${last ?? ""}`.trim();
  return name || fallback;
}

export function initials(
  first?: string | null,
  last?: string | null,
  fallback = "T",
): string {
  const value = `${first?.[0] ?? ""}${last?.[0] ?? ""}`.toUpperCase();
  return value || fallback;
}

export function formatPhone(
  countryCode?: string | null,
  phone?: string | null,
): string {
  if (!phone) return "—";
  return `${countryCode ?? ""} ${phone}`.trim();
}

/** Fecha de hoy en formato yyyy-MM-dd (para inputs type="date") */
export function todayISO(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
